import { useWindowSize } from '@zg-rentals/react-hooks';
import { BREAKPOINTS } from '../constants/breakpoints';

/**
 * @description Determines the current browser window width.
 * isMobileView (for browser widths < 1023px).
 * isDesktopView (for browser widths >= 1024px).
 * @returns Object
 */
export default () => {
  const { width } = useWindowSize();

  return {
    isMobileView: width < BREAKPOINTS.lgMin,
    isDesktopView: width >= BREAKPOINTS.lgMin,
    isWindowWidthSet: width !== 0,
  };
};
